import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import filterChildren from '../../utils/Children/filterChildren';
import cn from '../../../utils/cn';

const Tabs = ({
  id = '',
  className = '',
  style = {},
  value,
  onChange,
  children = [],
}) => {
  const [content, setContent] = useState(null);

  const handleSetContent = useCallback((newContent) => {
    setContent(newContent);
  }, []);

  const tabsClass = cn(
    'relative',
    className
  );

  const newChildren = filterChildren(children, {
    onChange,
    setContent: handleSetContent,
    activeTab: value,
  });

  return (
    <div id={id} className={tabsClass} style={style}>
      {newChildren}
      {content}
    </div>
  );
};

Tabs.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** selects the tab whose value prop matches this prop. */
  value: PropTypes.string.isRequired,
  /** Called when the selected value change. */
  onChange: PropTypes.func.isRequired,
  /** children props for content inside */
  children: PropTypes.node,
};

export default Tabs;
